import { render, staticRenderFns } from "./PracticeExamSettings.vue?vue&type=template&id=780394fe&scoped=true"
import script from "./PracticeExamSettings.vue?vue&type=script&lang=js"
export * from "./PracticeExamSettings.vue?vue&type=script&lang=js"
import style0 from "./PracticeExamSettings.vue?vue&type=style&index=0&id=780394fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780394fe",
  null
  
)

export default component.exports